import application from 'application/application';

application

	.value('validationFeedbacks', {
		invalid: [
			{
				type: 'required',
				feedback: 'Campo obrigatório.'
			},
			{
				type: 'number',
				feedback: 'Número inválido.'
			},
			{
				type: 'mail',
				feedback: 'E-mail inválido.'
			},
			{
				type: 'email',
				feedback: 'E-mail inválido.'
			},
			{
				type: 'equals',
				feedback: 'O valor não corresponde com o valor do campo principal.'
			},
			{
				type: 'document',
				feedback: 'Documento inválido.'
			}
		]
	});
